<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="20">
          <Mlogin />
          <DocumentsNewsBlockControl></DocumentsNewsBlockControl>
          <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19" class="right">
            <div class="grid-content bg-purple-light">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="17" :lg="17" :xl="17">
                  <div class="allbox">
                    <div class="title_all">
                      <div class="title_left">期刊简介</div>
                      <div class="title_more">
                        <router-link to="/FixedBody?ItemId=10"></router-link>
                      </div>
                    </div>
                    <div style="padding: 10px 15px">
                      <el-row :gutter="25">
                        <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                          <img :src="ImgUrl + imgUrl" alt width="100%" />
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="17" :lg="17" :xl="17">
                          <div v-html="qkBody"></div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <div class="dqml fifth">
                    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                      <el-tab-pane label="最新一期" name="first" class="buttona">
                        <IssueArticleListControl :type="type" v-if="isyuchuban == false" :List="List" :isdataa="true"
                          :newListTitle="newListTitle" :Periods="Periods" :id="1" :scroll="true"
                          :CloumnList="CloumnList"></IssueArticleListControl>
                      </el-tab-pane>
                      <el-tab-pane label="最新录用" class="buttona" name="second" v-if="isycb">
                        <IssueArticleListControl :type="type" v-if="isyuchuban" :isycb="isycb" :List="newList"
                          :Periods="Periods" :id="1" :scroll="true"></IssueArticleListControl>
                      </el-tab-pane>
                      <el-tab-pane label="过刊浏览" name="third">
                        <ul class="allachive">
                          <li v-for="(item, index) in AchiveList" :key="index" style="line-height: 24px">
                            <span class="leftfloat">{{
                              item.PublishYear
                            }}</span>
                            <div class="leftfloat" style="width: 85%">
                              <a @click="AchivePath(item1.IssueId)" v-for="(item1, index) in item.Issue" :key="index">{{
                                item1.IssueNum }}</a>
                            </div>
                            <div class="clearfix"></div>
                          </li>
                        </ul>
                      </el-tab-pane>
                      <el-tab-pane label="下载排行" class="buttona" name="fifth">
                        <div class="scroll_list">
                          <Ranking :params="{
                            PageSize: 1000,
                            PageIndex: 0,
                            Type: 'Sort',
                            Key: 'ReadRank',
                          }"></Ranking>
                        </div>
                      </el-tab-pane>
                      <el-tab-pane label="浏览排行" class="buttona" name="fourth">
                        <div class="scroll_list">
                          <Ranking :params="{
                            PageSize: 1000,
                            PageIndex: 0,
                            Type: 'Sort',
                            Key: 'ViewRank',
                          }"></Ranking>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div class="dqml fifth">
                    <el-tabs v-model="activeNamesl" type="card">
                      <el-tab-pane label="推介论文" name="one" class="buttona" style="
                          height: 500px;
                          overflow: scroll;
                          overflow-x: hidden;
                        ">
                        <div class="recomList" v-for="(cont, i) in recomList" :key="i">
                          <div class="text">
                            <a class="title" v-html="cont.Title" @click="godigese(cont.ArticleID)"></a>
                            <p class="author" v-html="cont.AuthorsList"></p>
                            <div class="ml_Doi" v-if="cont.DOI">
                              <span>DOI:{{ cont.DOI }}</span>
                            </div>
                            <div class="content mt5">
                              <span @click="
                                todigest(
                                  $event,
                                  cont.ArticleID,
                                  cont.Title,
                                  type
                                )
                                " class="menthodsBut">
                                <i class="list_img liulan"></i>浏览(<span style="
                                    color: red;
                                    margin-right: 0px !important;
                                  ">{{ cont.View_Times }}</span>)
                              </span>
                              <span @click="goExport(cont.ArticleID)"><i class="icon1"></i>导出</span>
                              <span @click="
                                pdf(index, cont.PDFFile_Size, cont.ArticleID)
                                " v-if="cont.PDFFile_Size > 0"><i class="icon2"></i>PDF下载(<span style="
                                    color: red;
                                    margin-right: 0px !important;
                                  ">{{ cont.Read_Times }}</span>)</span>
                              <span @click="goHtml(cont.HtmlFileUrl)" v-if="cont.HtmlFileUrl"><i
                                  class="list_img browse"></i> [HTML]</span>

                              <span @click="oniscode(cont.HtmlFileUrl)" v-if="cont.HtmlFileUrl" title="扫码阅读HTML全文"><i
                                  class="icon3"></i>扫码</span>
                            </div>
                          </div>
                        </div>
                        <el-dialog v-model="centerDialogVisible" width="30%" center>
                          <p>扫码阅读HTML全文</p>
                          <vue-qr :text="codeId" :size="150" class="Qrcode"></vue-qr>
                        </el-dialog>
                        <el-dialog v-model="centerDialogVisibles" width="30%" center>
                          <vue-qr :text="codeId" :size="150" class="Qrcode"></vue-qr>
                        </el-dialog>
                      </el-tab-pane>
                      <el-tab-pane label="学术动态" name="two" class="buttona">
                        <Control :params="{ ColumnId: 11, PageSize: 100 }"></Control>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                  <div class="allbox">
                    <div class="title_all">
                      <div class="title_left">论文检索</div>
                    </div>
                    <div style="padding: 10px 15px">
                      <Search />
                    </div>
                  </div>
                  <div class="allbox mt15">
                    <div class="title_all">
                      <div class="title_left">行业资讯</div>
                      <div class="title_more">
                        <router-link to="/DocumentList?ColumnId=4"></router-link>
                      </div>
                    </div>
                    <Control :params="{ ColumnId: 4, PageSize: 7 }"></Control>
                  </div>
                  <div class="allbox mt15" style="
                      background: #bcdcff;
                      border: 1px #89baef solid;
                      padding: 12px 15px;
                      border-radius: 5px;
                    ">
                    <div class="left">分享到：</div>
                    <div class="left">
                      <div class="share-bar">
                        <div class="share-container">
                          <a @click="
                            shareTo(
                              'wechat',
                              'http://www.17sensor.com/#/',
                              '仪表技术与传感器'
                            )
                            " title="微信">
                            <i class="fab  fa-wechat" style="font-size: 24px; color: #07c160"></i>
                          </a>
                          <a @click="
                            shareTo(
                              'weibo',
                              'http://www.17sensor.com/#/',
                              '仪表技术与传感器'
                            )
                            " title="微博">
                            <i class="fab  fa-weibo" style="font-size: 24px; color: #e6162d"></i>
                          </a>
                          <a @click="
                            shareTo(
                              'qq',
                              'http://www.17sensor.com/#/',
                              '仪表技术与传感器'
                            )
                            " title="QQ">
                            <i class="fab  fa-qq" style="font-size: 24px; color: #12b7f5"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>

                  <div class="allbox mt15">
                    <div class="title_all">
                      <div class="title_left">友情链接</div>
                      <div class="title_more">
                        <router-link to="/Links"></router-link>
                      </div>
                    </div>
                    <FrLinks></FrLinks>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import FixedBlockControl from "../components/Home/FixedBlockControl";
import IssueArticleListControl from "../components/IssueArticleListControl/IssueArticleListControl";
import xiazai from "@/assets/js/xiazai";
// import vueQr from 'vue-qrcode-component-v3'
import DocumentsNewsBlockControl from "../components/DocumentsNewsBlockControl/DocumentsNewsBlockControl";
import Search from "../components/Home/Search";
import FrLinks from "../components/DocumentsNewsBlockControl/page/FrLinks";
import Ranking from "../components/DocumentsNewsBlockControl/page/Ranking";
import Control from "../components/DocumentsNewsBlockControl/page/Control";
// 滚动列表
import vue3SeamlessScroll from "vue3-seamless-scroll";
export default {
  data() {
    return {
      keywords: "",
      activeName: "first",
      data: {},
      newList: [],
      List: [],
      Lista: [],
      isyuchuban: false,
      cotype: "",
      Periods: {},
      FileGUID: "",
      type: 0,
      SetItem: {},
      isycb: false,
      isycba: false,
      isLoginDown: false,
      isEBt: false,
      newListTitle: "",
      codeId: 0,
      centerDialogVisible: false,
      centerDialogVisibles: false,
      CloumnList: [],
      AchiveList: [],
      listData: [],
      otherInfo: "",
      imgUrl: "",
      qkBody: "",
      activeNamesl: "one",
      recomList: [],
      isImg: true,
    };
  },
  components: {
    FixedBlockControl,
    IssueArticleListControl,
    // vueQr,
    DocumentsNewsBlockControl,
    Search,
    FrLinks,
    Ranking,
    Control,
    vue3SeamlessScroll,
  },
  created() {
    this.getArticList();
    this.GetIssue();
    this.getSet(); //获取系统配置
    this.GetRecomList(); //推荐列表
    this.AchiveLists(); //过刊目录
    this.getnewslist();
    this.getProfiles(); //期刊信息
  },
  mounted() {
    if (this.$route.query.code) {
      this.$store
        .dispatch("_getWeiXinLogin", { Scene: this.$route.query.code })
        .then((res) => {
          localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
        });
    }
    if (this.$route.query.g) {
      window.location.href = "/#/ForgetPassword?Guid=" + this.$route.query.g;
    }
  },
  computed: {
    classOption() {
      return {
        step: 0.4, // 数值越大速度滚动越快
      };
    },
  },
  methods: {
    shareTo(platform, url, title) {
      const u = encodeURIComponent(url || window.location.href);
      const t = encodeURIComponent(title || document.title);
      const map = {
        weibo: `https://service.weibo.com/share/share.php?url=${u}&title=${t}`,
        qq: `https://connect.qq.com/widget/shareqq/index.html?url=${u}&title=${t}`,
        wechat: "#", // 微信需二维码
      };

      if (platform === "wechat") {
        this.codeId = url || window.location.href;
        this.centerDialogVisibles = true;
      } else {
        window.open(map[platform], "_blank");
      }
    },
    getProfiles() {
      let data = [1100];
      this.$store.dispatch("_getHeader", data).then((res) => {
        if (res.data.IsSuccess) {
          if (res.data.Data.length > 0) {
            this.qkBody = res.data.Data[0].Body;
          }
        }
      });
    },
    getnewslist() {
      let data = { ColumnId: 13 };
      this.$store
        .dispatch("_getActor", data)
        .then((res) => {
          this.listData = res.data.Data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toDetail(e, x, id) {
      e.preventDefault();
      if (x.DataType == "Text" || x.DataType == "文字") {
        let routeUrl = this.$router.resolve({
          path: "/NewsDetails",
          query: { ItemId: id },
        });
        window.open(routeUrl.href, "_blank");
      } else if (x.DataType == "File" || x.DataType == "文件") {
        if (x.FileGUID == "") {
          alert("下载失败,未发现文件");
          return;
        }
        var aa = x.FileGUID;
        var ac = x.Title;
        this.OpenGUIDFile(aa);
      } else if (x.DataType == "Link" || x.DataType == "链接") {
        window.open(x.Url.replace(/amp;/g, ""), "_blank");
      }
    },
    OpenGUIDFile(FileGUID) {
      this.$store
        .dispatch("_OpenGUIDFile", {
          FileGUID: FileGUID,
        })
        .then((res) => {
          if (res.data.IsSuccess) {
            this.$DownloadBase64File(res.data.Guid, 1);
          } else {
            this.$error(res.data.Message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    AchiveLists() {
      this.$store
        .dispatch("_getgok")
        .then((res) => {
          this.AchiveList = res.data.Data.Year;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AchivePath(id) {
      this.$router.push({
        path: '/OAList',
        query: { IssueId: id }
      });
    },
    getSet() {
      let params = [
        1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960,
        2900, 4553, 310, 4554,
      ];
      //1000:期刊名称
      //1001：期刊英文名称
      //4530：（否）隐藏/（是）显示预出版模块
      //6018:预出版模块显示 （否）文章列表/（是）预出版内容
      //6019：是否需要登录下载文件
      //230：显示/隐藏所有的评论功能
      //6055：显示/隐藏列表和详情页的英文标题，英文关键字，英文摘要
      //5000： ISSN编号
      //5010：CN编号
      //11:是否启用手机短信
      //2900:是否启用英文网刊
      this.$store
        .dispatch("_getSet", params)
        .then((res) => {
          this.SetItem = res.data.Data;
          sessionStorage.setItem("SetItem", JSON.stringify(res.data.Data));
          this.SetItem.map((item) => {
            if (item.SetItemID == 4530) {
              item.Item_Value == "是"
                ? (this.isycb = true)
                : (this.isycb = false);
            }
            if (item.SetItemID == 4553) {
              this.printNum = item.Item_Value;
            }
            if (item.SetItemID == 6018) {
              if (item.Item_Value == "是") {
                this._getLista(this.printNum);
              } else {
                this._getListb(this.printNum);
              }
            }
            if (item.SetItemID == 6019) {
              item.Item_Value == "是"
                ? (this.isLoginDown = true)
                : (this.isLoginDown = false);
            }
            //   if(item.SetItemID==6055){
            //  item.Item_Value="是"?this.isEBt=true:this.isEBt=false
            //   }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    godigese(ids) {
      this.$newOpen("/#/digest?ArticleID=" + ids);
    },

    oniscode(num) {
      this.centerDialogVisible = true;
      this.codeId = num;
    },
    handleClick(tab, event) {
      if (tab.index == "1") {
        this.type = 1;
        this.isyuchuban = true;
        this.newList = this.Lista;
      }
      if (tab.index == "0") {
        this.type = 0;
        this.isyuchuban = false;
        this.newList = this.List;
      }
    },
    getArticList() {
      let params = {
        PageSize: 0,
        IssueId: 0,
      };
      this.$store
        .dispatch("_getNewlist", params)
        .then((res) => {
          this.List = res.data.Data;
          this.Listb = res.data.Data;
          this.List.map((item) => {
            if (item.Column) {
              this.CloumnList.push(item);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    todigest(e, id, title, type) {
      let path = "";
      if (type == 0) {
        path = "/digest?ArticleID=" + id;
      } else {
        path = "/ScriptPrePrintDetailed?ArticleID=" + id;
      }
      // this._getLLCS(id);
      // this.getArticList();
      e.preventDefault();
      let routeUrl = this.$router.resolve({
        path: path,
        query: { ArticleID: id }
      });
      window.open(routeUrl.href, "_blank");
    },
    goExport(ids) {
      this.$newOpen("/#/Export?ids=" + ids);
    },
    GetIssue() {
      this.$store
        .dispatch("_getYear", { Id: -1 })
        .then((res) => {
          this.newListTitle = res.data.Data.YearIssue_NoTtitle;
          let data = {
            newYears: res.data.Data.Publish_Date,
            Volume: res.data.Data.Volume,
            CoverGUID: res.data.Data.CoverGUID,
            CoverSuffix: res.data.Data.CoverSuffix,
            YearIssue_NoTtitle: res.data.Data.YearIssue_NoTtitle,
          };

          sessionStorage.setItem("newYears", JSON.stringify(data));
          this.Periods = res.data.Data;
          this.imgUrl = res.data.Data.CoverGUID + res.data.Data.CoverSuffix;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    GetRecomList() {
      var time = new Date().getTime();
      let data = {
        PageSize: 1000,
        Type: "Sort",
        Key: "Recommended",
        PageIndex: 1,
      };
      this.$store
        .dispatch("_getListb", data)
        .then((res) => {
          if (res.data.IsSuccess) {
            this.recomList = res.data.Data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pdf(i, size, guid) {
      if (size <= 0) {
        alert("文件不存在");
        return;
      }
      this.$store.dispatch("_getPDF", { Id: guid }).then((Result) => {
        window.location.href = Result.request.responseURL;
      });
    },
    goHtml(url) {
      window.open(url, "_blank");
    },
    _getLista(num) {
      var time = new Date().getTime();
      this.$store
        .dispatch("_getLista", {
          PageSize: num,
          src: time,
        })
        .then((res) => {
          if (res.data.IsSuccess) {
            this.Lista = res.data.Data;
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },
    _getListb(num) {
      var time = new Date().getTime();
      this.$store
        .dispatch("_getListb", {
          PageSize: num,
          Type: "Sort",
          Key: "Preprint",
          src: time,
        })
        .then((res) => {
          if (res.data.IsSuccess) {
            this.Lista = res.data.Data;
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },
  },
};
</script>

<style>
a {
  color: #222222;
}

.qkjj .el-carousel {
  background: #fff;
}

.qkjj .el-carousel__item {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.item_banner .el-row {
  border: 1px #f1f1f1 solid;
  width: 48%;
  text-align: center;
  padding: 10px 12px;
  min-height: 284px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.09) 0px 6px 9px 0px;
  -moz-box-shadow: rgba(0, 0, 0, 0.09) 0px 6px 9px 0px;
  box-shadow: rgba(0, 0, 0, 0.09) 0px 6px 9px 0px;
}

.qkjj .el-carousel__indicators--horizontal {
  bottom: 20px;
}

.content span {
  margin-right: 15px;
  height: 21px;
  line-height: 21px;
  display: inline-flex;
}

.text {
  text-align: left;
}

.text .title {
  color: #333;
  font-size: 15px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
}

.qkjj .el-carousel--horizontal {
  overflow: hidden;
}

.text .author {
  line-height: 1.5;
  margin-bottom: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #666666;
}

.text .contentText {
  color: #6f6f6f;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  line-height: 1.5;
  margin-bottom: 5px;
  height: 40px;
}

.content span {
  cursor: pointer;
}

.recomList {
  padding: 12px 0;
  border-bottom: 1px #ededed solid;
}

.recomList:nth-child(1) {
  padding-top: 0 !important;
}

.content span i {
  display: inline-block;
  width: 19px;
  height: 19px;
  background: url("../assets/images/colum_arrow.png") no-repeat;
}

.content span .icon1 {
  background-position: 0px 2px;
}

.content span .icon2 {
  background-position: 0px -17px;
}

.content span .icon3 {
  background-position: 0px -36px;
}

.el-tabs--card>.el-tabs__header .el-tabs__item {
  border-bottom: none;
}

.dqml .el-tabs__nav-scroll {
  border-bottom: 1px #ededed solid;
}

.el-tabs__item {
  background: #4a90e2 !important;
  color: #fff !important;
  font-weight: bold !important;
}

.dqml .el-tabs__nav-scroll .el-tabs__item {
  border-bottom: none !important;
  border-radius: 3px 3px 0 0;
}

.el-carousel__indicator.is-active button {
  background: #fff !important;
}

td:nth-child(even) {
  padding: 0 !important;
  border-bottom: none !important;
}

.seamless-warp {
  height: 230px;
  overflow: hidden;
}

.share-bar {
  display: flex;
  gap: 12px;
}

.share-bar a {
  color: #fff;
  background: #409eff;
  padding: 6px 12px;
  border-radius: 4px;
  text-decoration: none;
}

.share-container {
  overflow: visible !important;
  width: auto !important;
}

/* ===== 分享弹窗整体 ===== */
.share-pop {
  padding: 12px !important;
  border-radius: 10px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid #ebeef5 !important;
  background: #ffffff !important;
  min-width: 170px !important;
  height: 60px !important;
  overflow: hidden;
  /* 或 auto，随你 */
}

/* ===== 图标容器 ===== */
.share-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  min-width: 140px;
  /* 保证三图标水平排布 */
}

/* ===== 单个图标链接 ===== */
.share-container a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #f5f7fa;
  transition: all 0.25s ease;
  text-decoration: none;
}

/* 图标本体 */
.share-container a i {
  font-size: 20px;
  transition: transform 0.25s ease;
}

/* ---- 各平台品牌色 ---- */
.share-container a.weibo {
  color: #e6162d;
}

.share-container a.wechat {
  color: #07c160;
}

.share-container a.qq {
  color: #12b7f5;
}

/* ---- hover 效果 ---- */
.share-container a:hover {
  background: #ecf5ff;
  transform: translateY(-2px);
}

.share-container a:hover i {
  transform: scale(1.15);
}

.fenxiang {
  min-width: 170px !important;
  height: 60px !important;
  overflow: auto;
}
</style>
